
export class Pagina {
    label: string;
    value: string;

    constructor(label: string, value: string) {
        this.label = label;
        this.value = value;
    }

    getDisplayName(): string {
        return `${this.label} - ${this.value}`;
    }
}